<template>
  <div class="w-100" id="p-zz" v-if="zizhiObj">
    <div class="h11 position-relative" id="p-story-1" style="top: -66px;"></div>
    <div class="b-title d-flex align-items-center">
      项目证书
    </div>
    <div class="h11 position-relative" id="p-zz-1"></div>
    <div class="p-zizhi" >
<!--      <img :src="'https://api.aqjsjx.com.cn/project/certificate?projectId='+zizhiObj.id+'&certificateType=selfPreview'">-->
      <img :src="certificateImg">
    </div>
  </div>
</template>

<script>
  export default {
    name: "advZiZhi",
    data() {
      return {
        certificateImg: '/static/img/pro/certificate.png'
      }
    },
    props: [
      'zizhiObj'
    ]
  }
</script>

<style>

</style>
